import { FC, memo } from 'react';

import { AvatarPlaceholder, AvatarPlaceholderType } from '@gem/components';
import { Skeleton } from '@gem/ui-kit';

import { useSyncAnimations } from '../hooks/useSyncAnimations';
import styles from './SchedulesCallInviteesPlaceholder.styles.m.css';

interface ISchedulesCallInviteesPlaceholderProps {
  count?: number;
}

export const SchedulesCallInviteesPlaceholder: FC<ISchedulesCallInviteesPlaceholderProps> = memo(
  (props) => {
    const { count = 20 } = props;

    const { isFirstAnimated, isSecondAnimated } = useSyncAnimations({
      firstTimeout: 500,
      secondTimeout: 1000,
    });

    return (
      <>
        {Array.from({ length: count }, (_, key) => {
          return (
            <div
              className={styles.avatar}
              key={key}
            >
              <AvatarPlaceholder
                type={AvatarPlaceholderType.Round_0}
                isAnimated={isFirstAnimated}
              />

              <Skeleton
                className={styles.avatarLine}
                width="192px"
                height="24px"
                borderRadius="6px"
                isAnimated={isSecondAnimated}
                animationConfig={{
                  duration: 1000,
                  endPosition: '192px',
                }}
              />
            </div>
          );
        })}
      </>
    );
  }
);
